import React, { Component } from 'react';
import { Row, Col } from 'react-flexbox-grid';

class FormFooter extends React.Component {
  render() {
    return (
      <div>
        <Row>
          <Col xs={12}>
            <hr className="separator" />
          </Col>
        </Row>
        <Row className="buttons">
          <Col xs={12} sm={6}>
            <a href='https://www.facebook.com/cnmt.co/' className='social-button social-button--facebook'>Наш Facebook</a>
          </Col>
          <Col xs={12} sm={6}>
            <a href='https://www.youtube.com/channel/UCbCSmEMD1er5Ali3Z2bR18g' className='social-button social-button--youtube'>Наш Youtube</a>
          </Col>
        </Row>
      </div>
    )
  }
}

export default FormFooter;


// WEBPACK FOOTER //
// ./src/components/form/FormFooter.js